import { httpMethods } from 'enums';
import { Http } from 'library';
import api from 'api/client';
import {
  CognitoUser,
  AuthenticationDetails,
  CognitoUserAttribute,
} from 'amazon-cognito-identity-js';

import * as Endpoints from 'constants/endpoints.constant';
import { UserPool } from './UserPool';

class AuthHttp {
  static signIn = (payload: any) => {
    const user: CognitoUser = new CognitoUser({
      Username: payload.email,
      Pool: UserPool,
    });

    const authDetails = new AuthenticationDetails({
      Username: payload.email,
      Password: payload.password,
    });
    // eslint-disable-next-line no-async-promise-executor
    return new Promise(async (resolve, reject) => {
      user.authenticateUser(authDetails, {
        onSuccess: (data) => {
          resolve(data);
        },

        onFailure: (err) => {
          // setLoginFailed(true);
          console.error('onFailure:', err);
          reject(err);
        },
      });
    });
  };

  static signUp = (payload: any) => {
    console.log(payload);

    // const userTimestamp = moment().unix();
    // const stringUserTimestamp = userTimestamp.toString();
    // const user: CustomTypes.CognitoUser = {
    //     email,
    //     password,
    //   };
    const attributesToBeAdded = [
      {
        Name: 'family_name',
        Value: payload.name,
      },
      {
        Name: 'phone_number',
        Value: payload.mobile,
      },
    ];
    const attrList: Array<CognitoUserAttribute> = attributesToBeAdded.map(
      (attr) => new CognitoUserAttribute(attr)
    );
    UserPool.signUp(
      payload.email,
      payload.password,
      attrList,
      null,
      (err, result) => {
        if (err) {
          console.log(err);

          // setLoading(false);
          // setError(err.message);
          return;
        }
        // setLoading(false);
        if (result && result.user) {
          console.log(result);

          // setUsername(user.email);
          // setUserId(result.userSub);
          // setTimestamp(+stringUserTimestamp);
          // openConfirmationCodeModal(true);
        }
      }
    );
  };

  static signOut = () =>
    Http.setMethod(httpMethods.post)
      .setUrl(Endpoints.SIGN_OUT)
      .setToken(api.getToken())
      .request();
}

export default AuthHttp;
